export default __webpack_public_path__ + "static/media/github-white.d62d053f.png";